import axios from 'axios';

import { TimePeriod, WeekDay } from 'utils/date';
import { getCurrentlyLoggedInEmployeeId } from 'utils/misc';

import { EMPLOYEES_WORK_PATTERNS, WORK_PATTERNS } from 'RestAPIs/endpoints';

type WorkPatternDutyPeriodResponse = {
  startTime: TimePeriod;
  endTime: TimePeriod;
  dutyHourTypeId: number;
};

export type WorkPatternDuty = {
  weekNumber: number;
  dayOfWeek: WeekDay;
  workAgreementId: number;
  costCenterId: number;
  periods: WorkPatternDutyPeriodResponse[];
};

export type WorkPatternResponse = {
  id: number | null;
  employeeId: number;
  startDate: string; // 1970-01-01
  endDate?: string | null; // 1970-01-01
  numberOfWeeks: number;
  duties: WorkPatternDuty[];
};

export type WorkPatternRequest = {
  startDate: string;
  endDate?: string | null;
  numberOfWeeks: number;
  duties: WorkPatternDuty[];
};

export const getWorkPatterns = (
  isEmployeePortal: boolean,
  employeeId?: number
) =>
  axios.get<WorkPatternResponse[]>(
    isEmployeePortal ? WORK_PATTERNS : EMPLOYEES_WORK_PATTERNS,
    {
      pathParams: {
        employeeId: employeeId ?? getCurrentlyLoggedInEmployeeId()
      }
    }
  );

type CreateBody = {
  request: WorkPatternRequest;
  employeeId?: number;
  isEmployeePortal: boolean;
};
export const createWorkPattern = ({
  request,
  employeeId,
  isEmployeePortal
}: CreateBody) =>
  axios.post(
    isEmployeePortal ? WORK_PATTERNS : EMPLOYEES_WORK_PATTERNS,
    { ...request },
    {
      pathParams: {
        employeeId: employeeId ?? getCurrentlyLoggedInEmployeeId()
      }
    }
  );

type UpdateBody = {
  request: WorkPatternRequest;
  employeeId?: number;
  workPatternId: number;
  isEmployeePortal: boolean;
};
export const updateWorkPattern = ({
  request,
  employeeId,
  workPatternId,
  isEmployeePortal
}: UpdateBody) =>
  axios.put(
    `${
      isEmployeePortal ? WORK_PATTERNS : EMPLOYEES_WORK_PATTERNS
    }/${workPatternId}`,
    { ...request },
    {
      pathParams: {
        employeeId: employeeId ?? getCurrentlyLoggedInEmployeeId()
      }
    }
  );

type DeleteBody = {
  employeeId?: number;
  workPatternId: number;
  isEmployeePortal: boolean;
};
export const deleteWorkPattern = ({
  employeeId,
  workPatternId,
  isEmployeePortal
}: DeleteBody) =>
  axios.delete(
    `${
      isEmployeePortal ? WORK_PATTERNS : EMPLOYEES_WORK_PATTERNS
    }/${workPatternId}`,
    {
      pathParams: {
        employeeId: employeeId ?? getCurrentlyLoggedInEmployeeId()
      }
    }
  );
